import { DEFAULT_IMAGE } from "@/lib/constant";
import { ImageLoader } from "../ui/image-loader";
import { type RouterOutputs } from "@/trpc/react";
import Link from "next/link";

type SpecialCategoryCardProps = RouterOutputs["trip_category"]["get_categories"][0]

export default function SpecialCategoryCard({ data }: { data: SpecialCategoryCardProps }) {
    return (
        <Link href={`/trending-trips/${data.slug}`} className="h-52 lg:h-48 xl:h-[16rem] group relative flex justify-center items-center cursor-pointer">
            <div className="absolute top-0 left-0 duration-500 group-hover:rotate-[-8deg] bg-gradient-to-br from-custom-primary/50 to-custom-secondary/80 rounded-xl shadow-sm shadow-sky-500 outline-[2.5px] outline outline-slate-200 -outline-offset-8 h-full w-full" />
            <ImageLoader
                src={data.card_image_url ?? DEFAULT_IMAGE}
                alt={data.title}
                fill
                className="object-cover rounded-xl"
            />
        </Link>

    )
}